import { Flex, Layout, ThemeConfig } from "antd";
import { Outlet, useOutletContext } from "react-router-dom";
import { ConfigProvider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { message } from "antd";
import { useEffect, useState } from "react";
import { LayoutHeader, type MenuItemEnabled, SideBar } from "@data-phone/react-generic";
import { GrTemplate } from "react-icons/gr";
import { MdOutlineSchedule } from "react-icons/md";
import { TbCode } from "react-icons/tb";
import { FaMailBulk, FaSms } from "react-icons/fa";
import { usePermissions } from "../../hooks/permissions";
import { GrDocumentConfig } from "react-icons/gr";
import { useGetCategories } from "../../hooks/apis/categories.api";
import { useGetTagsByCategory } from "../../hooks/apis/tags.api";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { setSelectedAccount } from "../../store/slices/admin.slice";
import { setSelectedConversation } from "../../store/slices/conversation.slice";
import { setSelectedDid } from "../../store/slices/SmsDids.slice";
import { IoSettingsOutline } from "react-icons/io5";
import { useGetConfig } from "../../hooks/apis/configurations.api";
import { useGetContacts } from "../../hooks/apis/contacts.api";
import { useGetAccounts } from "../../hooks/apis/accounts.api";
import { useGetTemplates } from "../../hooks/apis/templates.api";
import { useLocation } from "react-router-dom";
import { useGetAllUsers, useGetUsersByDids } from "../../hooks/apis/user.api";
import { useGetSmsDids } from "../../hooks/apis/SmsDids.api";
import { isElectronShell } from "../../utils/electron";
import { useSmsProtocolDidPicker } from "../../hooks/electron/useSmsProtocolDidPicker";
import { useElectronIncomingSmsNotification } from "../../hooks/electron/useElectronIncomingSmsNotification";
import { useElectronSmsNotificationBridge } from "../../hooks/electron/useElectronSmsNotificationBridge";
import SmsProtocolDidModal from "../Messages/electron/SmsProtocolDidModal";


const DefaultLayout = ({ logout }: { logout: () => void }) => {
  const dispatch: AppDispatch = useDispatch();
  const inElectronShell = isElectronShell();
  const smsProtocolPicker = useSmsProtocolDidPicker();

  useElectronIncomingSmsNotification(inElectronShell);
  useElectronSmsNotificationBridge(inElectronShell);

  const layoutStyle: React.CSSProperties = {
    height: "100vh",
    background: "#ffffff !important",
  };
  const { hasPermission, hasPermission2 } = usePermissions();

  const location = useLocation();

  const user = useSelector((state: RootState) => state.sessionData.data);

  const [messageApi, contextHolder] = message.useMessage();
  const { selectedAccount, accounts } = useSelector((state: RootState) => state.admin);
  const { selectedDid } = useSelector((state: RootState) => state.smsDids);

  const { refetch: fetchContacts } = useGetContacts();
  const { refetch: fetchAccounts } = useGetAccounts(hasPermission("accounts", ["read:any"]) || hasPermission2("accounts.view", "system") ? undefined : user?.accountID);
  const { refetch: fetchUsersByDid } = useGetUsersByDids([selectedDid as string]);
  const { refetch: fetchDids } = useGetSmsDids();
  const { refetch: fetchAllUsers } = useGetAllUsers()


  const [collapsed, setCollapsed] = useState(false);

  const { refetch: fetchCategories } = useGetCategories();
  const { refetch: fetchTags } = useGetTagsByCategory();

  const [account_id, setAccountId] = useState<string | null>(selectedAccount);

  useEffect(() => {
    if (account_id && account_id !== "") {
      dispatch(setSelectedAccount(account_id));
    }
  }, [account_id]);


  const { refetch: fetchConfig } = useGetConfig();

  const { refetch: fetchTemplates } = useGetTemplates();

  useEffect(() => {
    fetchDids()
    fetchCategories();
    fetchTags();
    fetchContacts();
    fetchTemplates()
    if(hasPermission("users", ["read:any","read:account"]) || hasPermission2("users.view", "account")) {
      fetchAllUsers();
    }
  }, [selectedAccount]);

  useEffect(() => {

    if (!selectedDid || !selectedAccount) {
      return
    }

    fetchUsersByDid();
  }, [selectedDid, selectedAccount]);


  useEffect(() => {
    fetchConfig();
  }, [selectedAccount])

  useEffect(() => {
    ((hasPermission("accounts", ["read:any"]) || hasPermission2("accounts.view", "system")) || (hasPermission("accounts", ["read:subAccount"]) || hasPermission2("accounts.subaccounts", "account"))) && fetchAccounts();
  }, []);

  useEffect(() => {
    dispatch(setSelectedConversation(null));
    dispatch(setSelectedDid(null));
  }, [selectedAccount]);


  const menu: {
    key: string;
    icon: JSX.Element;
    label: string;
    enabled: MenuItemEnabled;
    path: string;
  }[] = [
      {
        key: "sms",
        icon: (
          <FaSms
            style={{
              width: "30px",
              height: "30px"
            }}
            color="rgb(30, 27, 57)"
          />
        ),
        label: "SMS",
        path: "/",
        enabled: hasPermission("sms", ["readMessages:any", "readMessages:account", "readMessages:own"]) || hasPermission2("sms.messages.view", "own")
      },
      {
        key: "bulk",
        icon: (
          <FaMailBulk
            style={{
              width: "30px",
              height: "30px"
            }}
            color="rgb(30, 27, 57)"
          />
        ),
        label: "Bulk SMS",
        enabled: hasPermission("sms", ["sendBulkSms:any", "sendBulkSms:account", "sendBulkSms:own"]) || hasPermission2("sms.bulk_messages.send", "own") || 'locked-premium',
        path: "/bulk/send"
      },
      {
        key: "scheduled-messages",
        icon: (
          <MdOutlineSchedule
            style={{
              width: "30px",
              height: "30px"
            }}
            color="rgb(30, 27, 57)"
          />
        ),
        label: "Scheduled Messages",
        enabled: hasPermission("sms", ["readScheduledMessages:any", "readScheduledMessages:account", "readScheduledMessages:own"]) || hasPermission2("sms.scheduled_messages.view", "own"),
        path: "/scheduled-messages"
      },
      {
        key: "numbers",
        icon: (
          <GrDocumentConfig
            style={{
              width: "30px",
              height: "30px"
            }}
            color="rgb(30, 27, 57)"
          />
        ),
        label: "Numbers",
        enabled: hasPermission("sms", ["readDids:any", "readDids:account"]) || hasPermission2("sms.dids.view", "account"),
        path: "/numbers"
      },
      {
        key: "templates",
        icon: (
          <GrTemplate
            style={{
              width: "30px",
              height: "30px"
            }}
            color="rgb(30, 27, 57)"
          />
        ),
        label: "Templates",
        enabled: hasPermission("sms", ["readTemplates:any", "readTemplates:account", "readTemplates:own"]) || hasPermission2("sms.templates.view", "own"),
        path: "/templates"
      },
      {
        key: "integrations",
        icon: (
          <TbCode
            style={{
              width: "30px",
              height: "30px"
            }}
            color="rgb(30, 27, 57)"
          />
        ),
        label: "Integrations",
        enabled: hasPermission("users", ["read:any"]) || hasPermission2("users.view", "system"),
        path: "/integrations"
      },
      {
        key: "reports",
        icon: (
          <HiOutlineDocumentReport
            style={{
              width: "30px",
              height: "30px"
            }}
            color="rgb(30, 27, 57)"
          />
        ),
        label: "Reports",
        enabled: hasPermission("sms", ["readMessages:any", "readMessages:account", "readMessages:own"]) || hasPermission2("reports.sms.view", "own"),
        path: "/reports"
      },
      {
        key: "configurations",
        icon: (
          <IoSettingsOutline
            style={{
              width: "30px",
              height: "30px"
            }}
            color="rgb(30, 27, 57)"
          />
        ),
        label: "Configurations",
        enabled: hasPermission("sms", ["readUserConfigurations:any", "readUserConfigurations:account", "readUserConfigurations:own"]) || hasPermission2("sms.configurations.view.user", "own"),
        path: "/configurations"
      }
    ]

  const currentMenuItem = menu.find(item => item.path === location.pathname);

  return (
    <ConfigProvider
      theme={
        {
          token: {
            fontFamily: "Rethink Sans",
            colorPrimary: "#3e2ab5",
            controlItemBgActive: "#e2dff8"
          },
          components: {
            Segmented: {
              itemSelectedColor: "white",
              itemSelectedBg: "#3e2ab5",
              colorInfoActive: "white",
              colorSuccessActive: "white"
            }
          }
        } as ThemeConfig
      }
    >
      <Layout style={layoutStyle}>
        {contextHolder}
        {inElectronShell && smsProtocolPicker.modalOpen && smsProtocolPicker.pendingPhone && (
          <SmsProtocolDidModal
            open={smsProtocolPicker.modalOpen}
            phone={smsProtocolPicker.pendingPhone}
            dids={smsProtocolPicker.smsDids}
            isLoading={smsProtocolPicker.isLoading}
            onSelect={smsProtocolPicker.handleSelect}
            onClose={smsProtocolPicker.handleClose}
          />
        )}
        <Layout>
          {!inElectronShell && (
            <SideBar
              appMenu={menu.map(item => ({
                key: item.key,
                label: item.label,
                icon: item.icon,
                path: item.path,
                enabled: item.enabled
              }))}
              permissions={user?.permissions}
              accounts={accounts || []}
              appName="sms"
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              userAccount={user?.accountID as string}
              selectedAccountId={account_id as string}
              setSelectedAccountId={setAccountId}
            />
          )}
          <Flex style={{ width: inElectronShell ? "100%" : collapsed ? "calc(100% - 80px)" : "calc(100% - 260px)" }} vertical>
            <LayoutHeader
              color="rgb(245, 246, 247)"
              border="1px solid rgb(223, 226, 232)"
              logout={logout}
              name={`${user?.firstName} ${user?.lastName}`}
              email={user?.email || ""}
              title={currentMenuItem?.label || ""}
              icon={currentMenuItem?.icon || null}
            />
            <Flex style={{ height: "calc(100vh - 70px)" }}>
              <Outlet context={{ messageApi }} />
            </Flex>
          </Flex>
        </Layout>
      </Layout>

    </ConfigProvider>
  );
};

export default DefaultLayout;

export function useMessageToast() {
  return useOutletContext<any>();
}
